import React from 'react';
import { enumValue } from '~/util';

export interface NoteIconProps {
    action?: null | number;
}
export function NoteIcon({ action }: NoteIconProps) {
    function getIcon() {
        if (!action) return 'fa-regular fa-pen-to-square';
        switch (action) {
            case enumValue(['note', 'action', 'eSubmission document uploaded']):
            case enumValue(['note', 'action', 'eSubmission document renamed']):
                return 'fa-regular fa-file';
            case enumValue(['note', 'action', 'eSubmission document removed']):
            case enumValue(['note', 'action', 'Gap removed']):
            case enumValue(['note', 'action', 'eSubmission answer removed']):
                return 'fa-solid fa-times-circle';
            case enumValue(['note', 'action', 'New gap']):
            case enumValue(['note', 'action', 'New eSubmission answer']):
                return 'fa-solid fa-plus-circle';
            case enumValue(['note', 'action', 'Gap submitted']):
            case enumValue(['note', 'action', 'eSubmission submitted']):
            case enumValue(['note', 'action', 'Referral created']):
                return 'fa-regular fa-envelope';
            case enumValue(['note', 'action', 'Patient created']):
            case enumValue(['note', 'action', 'Patient status changed']):
            case enumValue(['note', 'action', 'Patient pcp changed']):
                return 'fa-regular fa-user';
            case enumValue(['note', 'action', 'eSubmission answer changed']):
            case enumValue(['note', 'action', 'Gap status changed']):
            case enumValue(['note', 'action', 'Review status expired']):
                return 'fa-regular fa-circle-right';
            case enumValue(['note', 'action', 'Task created']):
            case enumValue(['note', 'action', 'Task edited']):
            case enumValue(['note', 'action', 'Task status changed']):
            case enumValue(['note', 'action', 'Event transferred from source system']):
            case enumValue(['note', 'action', 'Event transferred to Zephyr']):
                return 'fa-solid fa-list-ul';
            default:
                return 'fa-regular fa-check-circle';
        }
    }

    return <i className={`me-1 ${getIcon()}`} />;
}
